import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type Userhotelrelationship from 'lumen/models/userhotelrelationship';
import type { Transition } from 'lumen/services/transition';

interface RouteParams {
  userEmail?: string;
  userId?: string;
}

export default class HotelSettingsUsersPropertyAccessRoute extends Route {
  queryParams = {
    userId: { refreshModel: true },
    userEmail: { refreshModel: false },
  };

  @service declare router: Services['router'];
  @service declare store: Services['store'];

  beforeModel(transition: Transition): void {
    const userId = transition.to?.queryParams?.['userId'];

    if (!userId) {
      this.router.transitionTo('hotel.settings.users');
    }
  }

  async model(params: RouteParams): Promise<Userhotelrelationship[]> {
    const results = await this.store.query('userhotelrelationship', {
      user_id: params.userId,
      page: 0,
    });

    return results.slice() as unknown as Userhotelrelationship[];
  }
}
